/// <amd-module name="TFS/Views/ProjectOverviewPage/Shared/ProjectMembersSource" />
import { Constants, ProjectMembersScenarios } from "TFS/Views/ProjectOverviewPage/Constants";
import { MembersData } from "TFS/Views/ProjectOverviewPage/Shared/Models";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssPerformanceService } from "VSS/Platform/Performance";

export class ProjectMembersSource {
    private static PROVIDER_ID = "ms.vss-tfs-web.project-members-data-provider-verticals";

    constructor(private _pageContext: IVssPageContext) {}

    public getProjectMembers(forceRefresh?: boolean): Promise<MembersData | undefined> {
        const performanceService = this._pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.startScenario(ProjectMembersScenarios.GetProjectMembers, false);

        return this._pageContext
            .getService<IVssContributionService>("IVssContributionService")
            .getDataAsync<MembersData>(ProjectMembersSource.PROVIDER_ID, forceRefresh ? { forceRefresh: true } : undefined, forceRefresh)
            .then(
                (data: MembersData | undefined) => {
                    performanceService.endScenario(Constants.Area, ProjectMembersScenarios.GetProjectMembers, false);
                    return data;
                },
                (error: Error) => {
                    performanceService.endScenario(Constants.Area, ProjectMembersScenarios.GetProjectMembers, false, undefined, { status: "failed" });
                    throw error;
                }
            );
    }
}
